import { render, staticRenderFns } from "./certified.vue?vue&type=template&id=6f5e75b3&scoped=true&"
import script from "./certified.vue?vue&type=script&lang=js&"
export * from "./certified.vue?vue&type=script&lang=js&"
import style0 from "./certified.vue?vue&type=style&index=0&id=6f5e75b3&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5e75b3",
  null
  
)

export default component.exports